import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { LayoutComponent } from './layout/layout.component';
import { CabecalhoComponent } from './componentes-ui/cabecalho/cabecalho.component';
import { AngularBaseUiModule } from 'app/angular-base-ui/angular-base-ui.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    CollapseModule,
    AngularBaseUiModule
  ],
  declarations: [
    LayoutComponent,
    CabecalhoComponent
  ],
  exports: [
    LayoutComponent,
    CabecalhoComponent
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/layout/layout.module.ts